import { render, staticRenderFns } from "./VoidItems.vue?vue&type=template&id=7cb9fe73&scoped=true&"
import script from "./VoidItems.vue?vue&type=script&lang=ts&"
export * from "./VoidItems.vue?vue&type=script&lang=ts&"
import style0 from "./VoidItems.vue?vue&type=style&index=0&id=7cb9fe73&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb9fe73",
  null
  
)

export default component.exports